// extracted by mini-css-extract-plugin
export default {"section":"VideoSection_section__7FoPY","container":"VideoSection_container__MaQ9P","videoWrapper":"VideoSection_videoWrapper__FXIls","iframe":"VideoSection_iframe__kajDt"};